import { Users, Route, Euro, Clock, Package, MapPin, Gauge } from 'lucide-react';
import { Money } from '../../components/Money';
import { fmtNum } from './utils';

function Kpi({ icon: Icon, label, value, sub, testId, accent }) {
  return (
    <div className="rounded-xl border border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-900 p-4" data-testid={testId}>
      <div className="flex items-center justify-between">
        <span className="text-xs text-slate-500 dark:text-slate-400">{label}</span>
        <Icon className={`h-4 w-4 ${accent}`} />
      </div>
      <div className="mt-1 text-xl font-bold text-slate-900 dark:text-slate-100">{value}</div>
      {sub && <div className="text-[11px] text-slate-400 mt-0.5">{sub}</div>}
    </div>
  );
}

export function TeamKpis({ team }) {
  return (
    <div className="grid grid-cols-2 md:grid-cols-4 xl:grid-cols-7 gap-3">
      <Kpi testId="team-kpi-drivers" icon={Users} accent="text-sky-500" label="Şoför" value={team.drivers} sub={`${team.days} aktif gün`} />
      <Kpi testId="team-kpi-routes" icon={Route} accent="text-blue-500" label="Toplam Rota" value={fmtNum(team.routes)} sub={`⌀ ${fmtNum(team.per_driver.routes, 1)} / şoför`} />
      <Kpi testId="team-kpi-revenue" icon={Euro} accent="text-emerald-500" label="Toplam Tutar" value={<Money amount={team.revenue} />} sub={<>⌀ <Money amount={team.per_driver.revenue} /> / şoför</>} />
      <Kpi testId="team-kpi-rph" icon={Gauge} accent="text-amber-500" label="⌀ Tutar / saat" value={<Money amount={team.revenue_per_hour} />} sub={<>⌀ <Money amount={team.per_driver_day.revenue} /> / şoför-gün</>} />
      <Kpi testId="team-kpi-hours" icon={Clock} accent="text-green-500" label="Toplam Saat" value={fmtNum(team.hours, 1)} sub={`⌀ ${fmtNum(team.hours_per_route, 1)} / rota`} />
      <Kpi testId="team-kpi-stops" icon={Package} accent="text-violet-500" label="Toplam Stop" value={fmtNum(team.stops)} sub={`⌀ ${fmtNum(team.stops_per_route, 1)} / rota`} />
      <Kpi testId="team-kpi-km" icon={MapPin} accent="text-orange-500" label="Toplam KM" value={fmtNum(team.km)} sub={`⌀ ${fmtNum(team.km_per_route, 1)} / rota`} />
    </div>
  );
}
